var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-form pt-1"},[_c('PageTable',{ref:"table",attrs:{"loading":_vm.loading,"tableData":_vm.tableData},on:{"reload":_vm.reload,"radio-change":function (e) { return _vm.$emit('radio-change', e); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }